<script>
  import moment from 'moment'
  import {getHistoricoLeiloesGrv} from '../../../../domain/grv/services'
  import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'
  import ACL from '../../../../domain/acl/tmp-acl'
  import { mapGetters } from 'vuex'

  export default {
    components: {},
    nome: 'historico-leiloes-grv',
    props: {
      grvId: {
        type: Number,
        default: () => 0,
        required: true
      }
    },
    data () {
      return {
        isLoaded: false,
        historicoLeiloes: [],
        urlLeilao: '/website/leiloes/'
      }
    },
    computed: {
      Status () {
        return Status.Status
      },
      ACL () {
        return ACL
      },
      ...mapGetters(['isLogged', 'currentUser'])
    },
    filters: {
      formatarData (date) {
        return moment(date).format('DD/MM/YYYY LT')
      }
    },
    created () {
      this.carregarHistoricoLeiloes()
      console.log(this.$router.currentRoute)
    },
    methods: {
      carregarHistoricoLeiloes () {
        if (!this.grvId) {
          alert('Este lote não possui uma grv relacionada')
          this.$emit('close')
          return
        }
        this.$parent.loading(true)
        getHistoricoLeiloesGrv(this.grvId)
          .then(response => {
            this.historicoLeiloes = response.data
          })
          .catch(error => {
            alert('Ocorreu um erro ao carregar o histórico de leilões')
            console.log(error)
          })
        .finally(() => {
          this.isLoaded = true
          this.$parent.loading(false)
        })
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Histórico de leilões</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel">
          <div class="panel-body">
            <div class="informacoes-historico m-b-lg">
              <div>Essa GRV já foi incluída em <span>{{historicoLeiloes.length}}</span> leil{{historicoLeiloes.length === 1 ? 'ão' : 'ões'}}</div>
            </div>
            <div v-if="historicoLeiloes.length">
              <table class="table-lotes-leilao table table-clicked table-striped bg-whit b-a">
                <thead>
                <tr>
                  <th class="text-nowrap text-center">LEILÃO</th>
                  <th class="text-nowrap text-center">DATA DE ABERTURA</th>
                  <th class="text-nowrap text-center">NÚMERO DE LOTE</th>
                </tr>
                </thead>
                <tbody>
                <tr class="leilao-list-lote-item" v-for="item in historicoLeiloes">
                  <td>
                    <router-link v-if="ACL.check('visualizar_leilao', currentUser.id)" :to="{name: 'leiloes.visualizar', params: {id: item.id}}" target="_blank" replace><u>{{item.titulo}}</u></router-link>
                    <span v-else>({{item.titulo}})</span>
                    <span>({{Status[item.status].titulo}})</span>
                  </td>
                  <td>{{item.dataAbertura.date | formatarData}}</td>
                  <td :style="{'color': !item.numeroLote ? 'red' :'black'}">
                  <router-link v-if="ACL.check('visualizar_leilao', currentUser.id)" :to="{name: 'lotes.visualizar', params: {leilao: item.id, id: item.loteId}}" target="_blank" replace>
                    <u>{{item.numeroLote || "Não numerado"}}</u>
                    </router-link>
                    <span v-else>({{item.numeroLote || "Não numerado"}})</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  td {
    text-align: center
  }
  .informacoes-historico {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
  .informacoes-historico span {
    font-weight: bold;
  }
  .resultado-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
</style>



// WEBPACK FOOTER //
// HistoricoLeiloesGrv.vue?33db8cb0